import type { AccountsTableColumnId } from '@/types/enums/accounts'

import accountsColumnDefinitions, {
  COLUMN_DISPLAY_NAMES,
} from '@/components/molecules/account-list-table/columns'
import {
  type AccountListConfig,
  AccountListConfigKeys,
  type ColumnState,
  FilterPaneState,
  QuickPreviewLocation,
  RowClickBehavior,
  ViewType,
} from '@/types/schema/page-configs/account-list'

export const defaultAccountListConfig: AccountListConfig = {
  [AccountListConfigKeys.FilterPaneState]: FilterPaneState.Closed,
  [AccountListConfigKeys.RowClickBehavior]: RowClickBehavior.Preview,
  [AccountListConfigKeys.QuickPreviewLocation]: QuickPreviewLocation.Right,
  [AccountListConfigKeys.ViewType]: ViewType.Standard,
  [AccountListConfigKeys.ColumnState]: defaultAccountListColumnState(),
}

function defaultAccountListColumnState(): ColumnState[] {
  return Array.from(accountsColumnDefinitions.values()).map((columnDef) => {
    const colId = columnDef.colId as AccountsTableColumnId
    return {
      colId,
      displayName: COLUMN_DISPLAY_NAMES[colId],
      visible: !columnDef.hide,
      width: columnDef.width,
    }
  })
}
